<template>
  <v-dialog v-model="isActive" @keydown.esc="close" max-width="800" scrollable>
    <v-card>
      <v-card-title class="title">{{ $t('prenotazioni.messaggi.trovata_incompatibilita') }}</v-card-title>
      <v-card-text class="text-pre-line">

        <v-expansion-panel>
          <v-expansion-panel-content
            v-for="(error, index) in errors" :key="index">
            <div slot="header" class="font-weight-medium">{{ error.message }}</div>
            <table class="error-table mx-5 my-3">
              <tr class=" warning--text">
                <th colspan="2">{{ $t('prenotazioni.label.dati_prenotazione_corrente') }}</th>
                <th colspan="2">{{ $t('prenotazioni.label.dati_prenotazione_incompatibile') }}</th>
              </tr>
              <tr>
                <td>{{ $t('label.id') }}:</td>
                <td> #{{ error.corrente.id }}</td>
                <td>{{ $t('label.id') }}:</td>
                <td> #{{ error.incompatibile.id }}</td>
              </tr>
              <tr>
                <td>{{ $t('label.data') }}:</td>
                <td>{{ $d($utils.date.toJs(error.corrente.data_controllo)) }} {{ $t('label.giorno_alle_ora') }} {{ error.corrente.ora_controllo }}</td>
                <td>{{ $t('label.data') }}:</td>
                <td>{{ $d($utils.date.toJs(error.incompatibile.data_controllo)) }} {{ $t('label.giorno_alle_ora') }} {{ error.incompatibile.ora_controllo }}</td>
              </tr>
              <tr>
                <td>{{ $t('label.cliente') }}:</td>
                <td>{{ error.corrente.id_agricoltore }}</td>
                <td>{{ $t('label.cliente') }}:</td>
                <td>{{ error.incompatibile.id_agricoltore }}</td>
              </tr>
              <tr>
                <td>{{ $t('label.tecnico') }}:</td>
                <td>{{ (error.corrente.id_tecnico || '-') }}</td>
                <td>{{ $t('label.tecnico') }}:</td>
                <td>{{ (error.incompatibile.id_tecnico || '-') }}</td>
              </tr>
              <tr>
                <td>{{ $t('label.unita_mobile') }}:</td>
                <td>{{ (error.corrente.targa || '-') }}</td>
                <td>{{ $t('label.unita_mobile') }}:</td>
                <td>{{ (error.incompatibile.targa || '-') }}</td>
              </tr>
            </table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn flat color="warning" @click="close">{{ $t('azioni.annulla') }}</v-btn>
        <v-btn color="warning" @click="onConfirm">{{ $t('azioni.conferma') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'

export default {
    name: 'PrenotazioneWarningDialog',
    mixins: [Toggleable],
    data: () => ({
        internalErrors: []
    }),
    computed: {
        errors () {
            return this.internalErrors.map(({ errore, prenotazioni }) => {
                let indexCorrente = this.edit ? (prenotazioni.findIndex(item => item.id === this.form.id)) : (prenotazioni[0].id > prenotazioni[1].id ? 0 : 1)

                let message = this.getError(errore)
                let corrente = prenotazioni[indexCorrente]
                let incompatibile = prenotazioni[indexCorrente === 0 ? 1 : 0]

                return { message, corrente, incompatibile }
            })
        }
    },
    methods: {
        show (errors) {
            this.internalErrors = errors
            this.isActive = true
        },
        close () {
            this.isActive = false
        },
        onConfirm () {
            this.$emit('confirm')
        },
        getError (error) {
            switch (error) {
            case 'agri':
                return this.$t('prenotazioni.messaggi.incomp_agri')
            case 'tecnici':
                return this.$t('prenotazioni.messaggi.incomp_tecnici')
            case 'unita_mobile':
                this.$t('prenotazioni.messaggi.incomp_unita_mobile')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
  .error-table {
    th, td:nth-child(2n) {
      font-weight: 500;
      padding-right: 4px;
      padding-bottom: 2px;
    }

    td:nth-child(3), th:nth-child(2) {
      padding-left: 100px;
    }

    th {
      padding-bottom: 8px;
      text-align: left;
      font-size: 16px !important;
      line-height: 1 !important;
      letter-spacing: 0.02em !important;
      margin-bottom: 6px;
      text-transform: uppercase;
    }
  }
</style>
